import { ETicketStatus } from '@constants';

import { defaultTheme } from '../styles/theme';

export const TICKET_STATUS_COLORS = {
  [ETicketStatus.NEW]: defaultTheme.colors.purple2,
  [ETicketStatus.IN_PROGRESS]: defaultTheme.colors.orange2,
  [ETicketStatus.CLOSED_NOT_RESOLVED]: defaultTheme.colors.red2,
  [ETicketStatus.CLOSED_RESOLVED]: defaultTheme.colors.green2
};

export const TICKET_LABEL_STATUS_COLORS = {
  [ETicketStatus.NEW]: defaultTheme.colors.purple7,
  [ETicketStatus.IN_PROGRESS]: defaultTheme.colors.orange8,
  [ETicketStatus.CLOSED_NOT_RESOLVED]: defaultTheme.colors.red6,
  [ETicketStatus.CLOSED_RESOLVED]: defaultTheme.colors.green7
};
